import React, { useEffect, useState } from "react";

import { TemplateProps } from "src/components/templates/types";

import styles from "src/components/templates/CabinetTemplate/styles.module.css";
import { AuthHeader } from "src/components/organisms/AuthHeader";
import { TabLinks } from "src/components/molecules/TabLinks";
import { ProfileInfo } from "src/components/organisms/ProfileInfo";
import { Tab, TabItem } from "src/components/molecules/Tab";
import { useLocation } from "react-router-dom";
import { useRedirect } from "src/navigation/useRedirect";
import { PAGES, MODALS } from "src/types/navigation";
import { useIsMobile } from "src/hooks/useIsMobile";
import { MobileAuthHeader } from "src/components/organisms/MobileAuthHeader";
import { ReferalInfo } from "src/components/organisms/ReferalInfo";
import { Footer } from "src/components/organisms/Footer";
import { AddEventModal } from "src/components/organisms/AddEventModal";
import { MenuBottomBar } from "src/components/molecules/MenuBottomBar";
import { MobileMenu } from "src/components/molecules/MobileMenu";
import { PromoCodeModal } from "src/components/organisms/PromoCodeModal";
import { OnboardingModal } from "src/components/organisms/OnboardingModal";
import { useSelector } from "react-redux";
import { RootState } from "src/store";

const linkItems: TabItem[] = [
  {
    value: PAGES.POSITIONS,
    label: "components.templates.CabinetTemplate.position",
  },
  {
    value: PAGES.HISTORIES,
    label: "components.templates.CabinetTemplate.history",
  },
  {
    value: PAGES.EVENTS,
    label: "components.templates.CabinetTemplate.events",
  },
  {
    value: PAGES.NOTIFICATIONS,
    label: "components.templates.CabinetTemplate.notifictaions",
  },
  {
    value: PAGES.REFERALS,
    label: "components.templates.CabinetTemplate.referals",
  },
];

//TODO move this logic in redux after getting login data
export const CabinetTemplate: React.FC<TemplateProps> = ({ children }) => {
  const [isOpenEventModal, setIsOpenEventModal] = useState(false);
  const [isOpenPromoModal, setIsOpenPromoModal] = useState(false);
  const [isOnboardingOpen, setIsOnboardingOpen] = useState(false);

  const [isCollapse, setIsCollapse] = useState(false);
  const { pathname } = useLocation();
  const { redirect, openModal } = useRedirect();
  const user = useSelector((state: RootState) => state.profile.user);

  useEffect(() => {
    // Проверяем, только что ли пользователь зарегистрировался
    const justLoggedIn = sessionStorage.getItem('justLoggedIn');

    if (justLoggedIn && user?.id) {
      setIsOnboardingOpen(true);
      sessionStorage.removeItem('justLoggedIn');
    }
  }, [user?.id]);

  // Закрываем боковую шторку при любой смене маршрута. Профиль/Рефералы (и др.
  // cabinet-страницы) рендерятся в общем CabinetLayout, который НЕ перемонтируется
  // при переходе между ними, поэтому состояние шторки нужно сбрасывать явно.
  useEffect(() => {
    setIsCollapse(false);
  }, [pathname]);

  const handleCloseOnboarding = () => {
    setIsOnboardingOpen(false);
  };

  const openOnboardingModal = () => {
    setIsOnboardingOpen(true);
  };

  const isMobile = useIsMobile();
  const isReferalPage = pathname === PAGES.REFERALS;

  const handleItemSelect = (value: string) => {
    redirect({ scheme: value as PAGES });
  };
  const handleCollapseMenu = () => setIsCollapse((prev) => !prev);

  return (
    <div className={styles.root}>
      <div className={styles.headerWrapper}>
        {isMobile ? (
          <MobileAuthHeader
            handleCollapseMenu={handleCollapseMenu}
            openOnboardingModal={openOnboardingModal}
          />
        ) : (
          <AuthHeader
            openEventModal={() => setIsOpenEventModal(true)}
            openDepositModal={() => openModal({ scheme: MODALS.DEPOSIT })}
            openOnboardingModal={openOnboardingModal}
          />
        )}

        <TabLinks />
      </div>
      <div className={styles.contentParent}>
        <div className={styles.children}>
          {isReferalPage ? <ReferalInfo /> : <ProfileInfo />}

          <Tab
            items={linkItems}
            onItemSelect={handleItemSelect}
            activeTab={pathname ?? linkItems[0].value}
            underlinedValue={PAGES.REFERALS}
          />
          {children}
        </div>
      </div>
      {!isMobile && <Footer />}
      <AddEventModal
        isOpen={isOpenEventModal}
        close={() => setIsOpenEventModal(false)}
      />
      <PromoCodeModal
        isOpen={isOpenPromoModal}
        close={() => setIsOpenPromoModal(false)}
      />
      <OnboardingModal
        isOpen={isOnboardingOpen}
        close={handleCloseOnboarding}
      />

      {isMobile && isCollapse && (
        <MobileMenu
          close={handleCollapseMenu}
          openDepositModal={() => openModal({ scheme: MODALS.DEPOSIT })}
          openEventModal={() => setIsOpenEventModal(true)}
          openPromoModal={() => setIsOpenPromoModal(true)}
          openOnboardingModal={openOnboardingModal}
        />
      )}

      {isMobile && <MenuBottomBar handleCollapseMenu={handleCollapseMenu} />}
    </div>
  );
};
